<template>
  <div class="flex-container bottom-bar">
    <price></price>
    <quantity-selector></quantity-selector>
    <div class="button-actions">
      <add-to-cart></add-to-cart>
    </div>
  </div><!-- /.flex-container -->
</template>

<script>
import Price from "@/components/previewer/Price"
import QuantitySelector from "@/components/previewer/QuantitySelector"
import AddToCart from './AddToCart'
import { mapState, mapActions } from "vuex"

export default {
  name: "Previewer",
  components: {
    Price,
    QuantitySelector,
    AddToCart
  }
};
</script>
